import { Component, OnInit, output } from "@angular/core";

@Component({
  selector: "av-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.scss"],
  standalone: false,
})
export class SearchComponent implements OnInit {
  readonly queryChange = output<string>();

  query: string;

  constructor() {}

  ngOnInit(): void {}

  change(value) {
    this.queryChange.emit(value);
  }
}
